import { jwtDecode } from "jwt-decode";
import { DecodedToken } from "./DecodedToken";

export const getUserInfoFromToken = (
  token: string
): DecodedToken | null => {
  if (!token) return null;

  try {
    const decoded: DecodedToken = jwtDecode(token);
    return {
      email: decoded.email,
      role: decoded.role,
    };
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};
